/**
 * Shop Submenu - Image Hover
 */

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(init, 100);
});

function init() {
  const submenu = document.querySelector('.shop-submenu');
  if (!submenu) return;

  const links = submenu.querySelectorAll('[data-collection]');
  const images = submenu.querySelectorAll('.shop-submenu-image img');
  const overlay = submenu.querySelector('.shop-submenu-overlay span');

  links.forEach(link => {
    link.addEventListener('mouseenter', function() {
      const handle = this.getAttribute('data-collection');

      // Hide all images
      images.forEach(img => img.classList.remove('active'));

      // Show matching image
      const targetImg = submenu.querySelector(`img[data-collection="${handle}"]`);
      if (targetImg) {
        targetImg.classList.add('active');
        if (overlay) overlay.textContent = `Bekijk ${this.textContent.trim()}`;
      }
    });
  });

  // Reset on mouse leave
  const leftCol = submenu.querySelector('.shop-submenu-col:first-child');
  if (leftCol) {
    leftCol.addEventListener('mouseleave', function() {
      images.forEach(img => img.classList.remove('active'));
      const defaultImg = submenu.querySelector('img[data-default]');
      if (defaultImg) defaultImg.classList.add('active');
      if (overlay) overlay.textContent = 'Bekijk';
    });
  }
}
